export default {
  message: {
    "error": "Oops! Something went wrong.",
    "Sorrysomeerrorsoccurred": "An unexpected error occurred. You can try switching the language or exit and restart the app.",
    "quit": "Quit",
    "language": "Language",
    "Youcanchangethelanguagehere": "You can change the language here!",
    "current": "Current",
    "home": "Home",
    "friends": "Friends",
    "wallet": "Wallet",
    "aboutus": "About Us",
    "Sharewithfriends": "Share with friends",
    "copyFailure": "Copy Failure",
    "copySuccess": "Copy Success",
    "Claimreward": "Claim reward",
    "DailyLogin": "Daily Login",
    "noInvitationsYet": "No Invitations Yet",
    "LoadMore": "Load More",
    "WatchAD": "Watch AD",
    "continue": "Continue",
    "Congratulations": "Congratulations",
    "MyFriends": "My Friends",
    "Invitefriends": "Invite friends",
    "Invitepremiumfriends": "Invite premium friends",
    "DailyTasks": "Daily tasks",
    "inviteDesc": "+{num} ${name} for each friend you invite",
    "DailyTasksDesc": "Complete tasks to get more airdrop",
    "SponsorsandPartners": "Sponsors and Partners",
    "Receivingwallet": "Receiving wallet",
    "Enterwalletaddress": "Enter {name} wallet address",
    "Claim": "Claim",
    "Earnings": "Earnings",
    "learnMore": "Learn more",
    "claimSuccess": "Claimed successfully",
    "claimFailed": "Claim failed, please try again",
    "noDividends": "No dividends to claim",
    "dividendsInfoFallback": "Invite friends to earn referral rewards",
    "Booster": "Booster",
    "RentPeriod": "Rent Period",
    "days30": "30 days",
    "Dailyprofit": "Daily profit",
    "Totalprofit": "Total profit",
    "Quantity": "Quantity",
    "RentPrice": "Rent Price",
    "RentMiner": "Rent Miner",
    "Insufficient": "Not enough invitees",
    "InsufficientMsg": "You need to invite {num} friends to earn more accessories.",
    "Settings": "Settings",
    "copyid": "Copy ID",
    "UpgradeSuccessfully": "Upgrade Successfully",
    "Name": "Name",
    "userinfo": "Userinfo",
    "disconnect": "Disconnect",
    "Startmining": "Start mining",
    "Welcome": "Welcome to {name}",
    "Withdrawal": "Withdrawal",
    "Minimumamount": "Minimum amount",
    "Networkfee": "Network fee",
    "Enteramount": "Enter amount",
    "Submit": "Submit",
    "MinimumTip": "The withdrawal amount is too small. Minimum withdrawal amount: {num}",
    "MaximumTip": "Insufficient amount, the maximum amount you can withdraw is: {num}",
    "SubmittedTip": "Submitted, expected to be processed within 30-60 working days",
    "WebSubmittedTip": "Submitted, we will process it as soon as possible.",
    "WithdrawStatus": "Status",
    "Submissiontime": "Submission time",
    "WithdrawAwaitTip": "* It is estimated to take 30-60 working days. Inviting more friends can speed up the review process.",
    "WebWithdrawAwaitTip": "* It is estimated to take 24-48 hours. Inviting more friends can speed up the review process.",
    "Processing": "Processing",
    "Success": "Success",
    "Rejection": "Rejection",
    "Amount": "Amount",
    "Numberoffriends": "Number of friends: {now}/{limit}",
    "InviteTipFirst": "To make your first withdrawal, you need to invite {limit} friends to join the mining app.",
    "InviteTip": "To complete the withdrawal process, you need to invite {limit} friends to join the mining app.",
    "openonphone": "Open this link on your phone.",
    "claimTip": "The amount to be claimed is too small. The minimum amount to be claimed is: {num}",
    "WalletBalance": "Wallet Balance",
    "Withdraw": "Withdraw",
    "SetWalletAddress": "Set Wallet Address",
    "WithdrawalRecord": "Withdrawal Record",
    "Norecords": "No records",
    "Whatis": "What is {name}?",
    "All": "All",
    "save": "Save",
    "successWithdrawal": "Scan success {num}",
    "secondsago": "{time} seconds ago",
    "Loading": "Loading...",
    "PaymentConfirming": "Checking Transaction Status...",
    "Check": "Check",
    "CheckFail": "Transaction not completed. Please check again in 5 seconds.",
    "Addname": "Add '{name}' to your name",
    "Restattcheck": "Restart the app to check",
    "Copyname": "Copy '{name}'",
    "SubmissionFailed": "Submission failed, please try again later",
    "WithdrawalReview": "Withdrawal review",
    "select_payment_method": "Select payment method",
    "total_amount": "Total amount",
    "next_step": "Next step",
    "creating_order": "Creating order...",
    "order_created": "Order created",
    "order_status": "Order status",
    "order_id": "Order ID",
    "order_amount": "Order amount",
    "order_status_desc": "Order status description",
    "payment_cancelled": "Payment cancelled",
    "opening_payment": "Opening payment...",
    "payment_success": "Payment successful",
    "payment_failed": "Payment failed",
    "payment_pending": "Payment pending",
    "payment_processing": "Payment processing",
    "create_order_failed": "Create order failed",
    "creating_ton_order": "Creating TON order...",
    "check_payment_status": "Checking payment status...",
    "use_ton_payment": "Use TON payment",
    "connect_wallet": "Connect wallet",
    "start_transaction": "Start transaction",
    "address": "Address",
    "amount_ton": "Amount TON",
    "copy": "Copy",
    "comment_memo": "Comment memo",
    "comment_memo_desc": "Please enter the comment memo",
    "comment_memo_placeholder": "Enter comment memo",
    "amount": "Amount",
    "wallet_address": "Wallet address",
    "you_can_choose_to_connect_wallet_to_pay": "You can choose to connect wallet to pay",
    "or_manually_transfer_to_the_above_address": "Or manually transfer to the above address (note that the amount and memo must be exactly the same)",
    "transaction_success": "Transaction success",
    "transaction_failed": "Transaction failed",
    "transaction_error": "Transaction error",
    "transaction_status": "Transaction status",
    "transaction_id": "Transaction ID",
    "transaction_amount": "Transaction amount",
    "transaction_status_desc": "Transaction status description",
    "miner_detail": "Miner detail",
    "rent_period": "Rent period",
    "days": "{days} days",
    "daily_yield": "Daily yield",
    "total_yield": "Total yield",
    "invite_friends": "Invite friends",
    "price": "Price",
    "rent": "Rent",
    "free_claim": "Free claim",
    "redeem": "Redeem",
    "buy": "Rent",
    "invite_friends_not_enough": "Invite friends not enough",
    "redeem_success": "Redeem success",
    "redeem_failed": "Redeem failed",
    "rent_success": "Rent success",
    "rent_failed": "Rent failed",
    "TotalPower": "Total Power",
    "MaxQuantity": "Maximum value reached",
    "Running": "Running",
    "Stop": "Stop",
    "Withdrawalunlock": "Withdrawal unlocking",
    "Close": "Close",
    "Delivering": "Delivering",
    "Duetothelargenumber": "Due to the large number of recipients,your airdrop is expected to arrive in 15-20 working days",
    "WithdrawalunlockTip": "You need {num} invited friends to complete tasks/bind wallets to unlock the withdrawal",
    "mining_title": "Robot",
    "OpenRobot": "Open Robot",
    "MyRobot": "My Robot",
    "Upgrade": "Upgrade",
    "partner": "Partner",
    "faq": "FAQ",
    "task": "Task",
    "Level": "Level",
    "Commission": "Commission",
    "DirectFriends": "Direct Friends",
    "Feedback": "Feedback",
    "Pleaseenteryouremailaddress": "Please enter your email address",
    "Inputfeedbackcontent": "Input feedback content",
    "Submitfeedback": "Submit feedback",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Feedback submitted successfully, thank you for your valuable feedback",
    "Feedbacksubmissionfailed,pleaseretriy": "Feedback submission failed, please try again",
    "Addressformaterror": "Address format error",
    "Readclipboardfailed": "Read clipboard failed",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "You have already feedbacked today, please come back tomorrow",
    "Record": "Record",
    "Newuserguidance": "View Welcome Tour",
    "Usetonwallet": "Use TON wallet",
    "Reward": "Reward",
    "Connectwallet": "Connect wallet",
    "Notconnected": "Not connected",
    "Disconnect": "Disconnect",
    "AboutTAI": "Token Details",
    "WithdrawalRecordDesc": "Withdrawal record",
    "StartScan": "Start Scan Wallet",
    "Next": "Next",
    "Start": "Start",
    "WithdrawalSuccess": "Withdrawal success",
    "WithdrawalFail": "Withdrawal fail",
    "Max": "Max",
    "WithdrawalRecords": "Withdrawal Records",
    "Commissionrules": "Commission rules",
    "Mycommission": "My commission",
    "Shop": "Shop",
    "BuyDifferentAIrobots": "Upgrade with compute devices for faster scans!",
    "CurrentRunningAIrobots": "Available compute",
    "DailyProfit": "Daily profit",
    "Buy": "Buy",
    "ValidityPeriod": "Validity period",
    "Days": "Days",
    "Price": "Price",
    "APY": "APY",
    "NoRobot": "No compute power",
    "RemainingTime": "Remaining time",
    "InviteandEarn": "Invite and earn",
    "InvitDec": "Invite your friends to join AI trading and earn USDT commissions and airdrop tokens together!",
    "ShareToGroups": "Share to groups",
    "Select_payment_method": "Select payment method",
    "twa_pay_tip_with_memo": "Please ensure the address, amount, and memo are consistent for the transfer.",
    "twa_pay_tip": "Please ensure the address and amount are correct for the transfer.",
    "check_transaction_status": "Check transaction status",
    "transaction_wait": "Transaction is processing. You can exit the app. A message will notify you once it is complete.",
    "realtime_ai": "Real-Time AI Trading",
    "Pleaseenteravalidemailaddress": "Please enter a valid email address",
    "max_robot_tip": "Purchase limit reached — try another plan to keep trading!",
    "connectFailure": "Connect wallet failed",
    "connectSuccess": "Connect wallet success",
    "PayNow": "Pay Now",
    "min_withdrawal_amount": "The minimum withdrawal amount is {num} {coin_name}",
    "max_withdrawal_amount": "The maximum withdrawal amount is {num} {coin_name}",
    "balance_not_enough": "You do not have enough balance for this withdrawal.",
    "Numberofgroups": "Number of groups: {now}/{limit}",
    "Withdraw_success": "Withdrawal successful",
    "allProfit": "Total profit",
    "AnnualProfit": "Annual profit",
    "ScanWallet": "Scan Wallet",
    "wallet_check": "wallet_check",
    "Found": "Found",
    "GoBuy": "Go Buy",
    "SpeedUpScan": "Speed Up",
    "ScanSpeed": "Scan speed",
    "MyComputingPower": "Compute",
    "Scanning": "Scanning!",
    "WithdrawDetail": "Withdrawal details",
    "ScanSuccess": "Your scan success rate has increased!",
    "TaskDescription": "Complete tasks to increase your scan success rate!",
    "InitializingMiningSystem": "Initializing scan system...",
    "NoWithdrawalRecord": "No withdrawal record",
    "Invite": "Required invites",
    "Free": "Free",
    "Confirm": "Confirm",
    "RefreshTasks": "Refresh tasks",
    "NumberofGroups": "Number of groups: {now}/{limit}",
    "SendMessage": "Send message",
    "NumberofShares": "Number of shares: {now}/{limit}",
    "NumberofTasks": "Number of tasks: {now}/{limit}",
    "CompleteTask": "Complete task",
    "Accelerated": "Accelerated",
    "Accelerated_withdrawals_success": "Accelerated withdrawals successfully"
}};